/** Largeur layout desktop forcée (Android / iOS / Safari) */
export const DESKTOP_VIEWPORT_WIDTH = 1400;

export const FORCE_DESKTOP_VIEWPORT = true;

/** Sidebar fixe à gauche en mode desktop forcé */
export const SIDEBAR_WIDTH_PX = 200;
